export default {
  tab(state) {
    return state.tab;
  },
};
